<template>

  <vx-card class="mb-base">
      <div class="vx-row">
        <div class="vx-col sm:w-1/2">
          <h5> {{ $t('class-room.course-outline-desc') }}</h5>
        </div>
        <div class="vx-col sm:w-1/2 text-right">

          <div class="flex float-right flex-end flex-wrap">

            <vs-button @click="navigateToHomeWork"
                       class="mr-2"
                       color="success" icon="icon-book" icon-pack="feather"
                       size="small" v-if="currentPage !== 'HOME_WORK'">
              {{ $t('teacher-dash-board.home-work') }}
            </vs-button>

            <vs-button @click="navigateToSubmitScore"
                       class="mr-2"
                       color="warning" icon="icon-upload" icon-pack="feather"
                       size="small" v-if="currentPage !== 'SUBMIT_SCORE'">
              {{ $t('teacher-dash-board.submit-score') }}
            </vs-button>

            <vs-button @click="navigateToStudentStat"
                       color="danger"
                       icon="icon-users" icon-pack="feather"
                       size="small" v-if="currentPage !== 'STUDENT_STAT'">
              {{ $t('teacher-dash-board.student-stat') }}
            </vs-button>

            <other-menu-drop-down v-if="classSectionCompute" :item="classSectionCompute"></other-menu-drop-down>

          </div>

          <!--<div class="vx-row">

            <div class="vx-col sm:w-1/3">
              <vs-button color="success" size="small"
                         icon-pack="feather" icon="icon-book">
                {{ $t('teacher-dash-board.home-work') }}
              </vs-button>
            </div>
            <div class="vx-col sm:w-1/3">
              <vs-button color="warning" size="small"
                         icon-pack="feather" icon="icon-upload">
                {{ $t('teacher-dash-board.submit-score') }}
              </vs-button>
            </div>
            <div class="vx-col sm:w-1/3">
              <vs-button color="danger" size="small"
                         icon-pack="feather" icon="icon-users">
                {{ $t('teacher-dash-board.student-stat') }}
              </vs-button>
            </div>

          </div>-->

        </div>
      </div>

      <vs-divider/>

      <div class="vx-row">

        <!-- Information - Col 1 -->
        <div class="vx-col flex-1">

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span class="font-semibold"> {{ $t('course-outline-registration.subject-code') }}</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <span v-if="subject">{{ subject.code }}</span>
              <span v-else>-</span>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span class="font-semibold"> {{ $t('course-outline-registration.subject-name') }}</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <span v-if="subject">{{ subject.nameLocal }}</span>
              <span v-else>-</span>
            </div>
          </div>

        </div>

        <!-- Information - Col 2 -->
        <div class="vx-col flex-1">

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span class="font-semibold"> {{ $t('course-outline-registration.credit') }}</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <span v-if="subject">{{ subject.creditCalGrade + ' ' + subject.creditDesc}}</span>
              <span v-else>-</span>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span class="font-semibold"> {{ $t('course-outline-registration.academic-period-short') }}</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <span v-if="courseOutlineRegistration">{{ courseOutlineRegistration.periodCode }}</span>
              <span v-else>-</span>
            </div>
          </div>

        </div>

        <!-- Information - Col 3 -->
        <div class="vx-col flex-1">

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span class="font-semibold"> {{ $t('class-room.class-section') }}</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <span v-if="classSectionCompute">{{ classSectionCompute.sectionNo }}</span>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span class="font-semibold"> {{ $t('class-room.class-section-learn-span-no') }}</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <span v-if="classSectionCompute">{{ classSectionCompute.learnSpanNo }}</span>
              <span v-else>-</span>
            </div>
          </div>


        </div>


      </div>
  </vx-card>

</template>

<script>
  import _store from '@/store';
  import ClassSection from '@/store/modules/courses/class-section/index';
  import {createNamespacedHelpers} from "vuex";
  import {createHelpers} from "vuex-map-fields";
  import OtherMenuDropDown from "../../../views/Home/Components/DropDownMenu/OtherMenuDropDown";

  if (!_store.state.ClassSection) _store.state.registerModule(`ClassSection`, ClassSection);

  const {
    mapActions: mapClassSectionActions,
  } = createNamespacedHelpers(`ClassSection`);


  const {
    mapFields: mapClassSectionFields,
  } = createHelpers({
    getterType: `ClassSection/getField`,
    mutationType: `ClassSection/updateField`,
  });

  export default {
    props: {
      classSectionId: {
        type: String,
        require: true,
      },
      currentPage: {
        type: String,
        require: true,
      }

    },
    components: {
      OtherMenuDropDown,
    },
    data() {
      return {
        classSection: {},
      }
    },
    computed: {
      ...mapClassSectionFields({
        studentAssignmentProcessing: 'processing',
      }),
      courseOutlineRegistration() {
        return this.classSection ? this.classSection.courseOutlineRegistration : null;
      },
      classSectionCompute() {
        return this.classSection ? this.classSection : null;
      },
      subject() {
        return this.classSection && this.classSection.courseOutlineRegistration
          ? this.classSection.courseOutlineRegistration.subject : null;
      },

    },
    methods: {
      //---------------------------------------- State Function ------------------------------------------------------//
      ...mapClassSectionActions({
        getClassSection: 'getClassSection',
      }),
      //---------------------------------------- Event Function ------------------------------------------------------//
      navigateToHomeWork() {
        this.$router.push({
          name: 'student-assignment',
          params: {
            classSectionId: this.classSection.id
          }
        })
          .catch(() => {
          })
      },
      navigateToSubmitScore() {
        this.$router.push({
          name: 'student-score',
          params: {
            classSectionId: this.classSection.id
          }
        })
          .catch(() => {
          })
      },
      navigateToStudentStat() {
        this.$router.push({
          name: 'student-stats',
          params: {
            classSectionId: this.classSection.id
          }
        })
          .catch(() => {
          })
      },
      //---------------------------------------- Local Function ------------------------------------------------------//
      async initData() {
        this.classSection = await this.getClassSection({id: this.classSectionId});
      },
    },
    async mounted() {
      await this.initData();
    }
  }
</script>

<style scoped>

</style>
